<template>
  <div class="Profile_Parent panel Administration_panel">
    <div class="inner_panel">
      <div
        style="display: flex; justify-content: flex-start; align-items: center"
      >
        <div class="protectedStatus">
          <img @load="imgLoaded" src="../assets/media/protected.svg" alt="" />
          {{ getBeautifiedRole() }}
        </div>
      </div>

      <h4 style="margin-bottom: 0.5rem">Structuri organizatorice</h4>

      <div
        :class="0 ? 'Administration_section_loading' : ''"
        class="Administration_panel_section"
      >
        <div v-if="isSuperadmin" class="form-group">
          <b class="asterisk">Instituția structurii organizatorice</b>
          <v-select
            :options="institutionaData"
            label="name"
            v-model="currentInstitution"
            append-to-body
          >
            <template #option="{ name }">
              <span class="v-select_li_custom">
                <span>{{ name }}</span>
                <i v-tooltip="name" class="fas fa-info-circle"></i>
              </span>
            </template>
          </v-select>
        </div>

        <h5 v-if="showTotalRecords">
          Total structuri organizatorice: {{ totalRecords }}
        </h5>

        <div class="departments-container">
          <div
            v-for="(item, index) in models"
            class="Administration_panel_block"
            :key="index"
            style="margin-bottom: 10px; margin-right: 2px"
          >
            <div class="form-flex">
              <div class="form-group noMB from-disabled">
                <b class="asterisk">Denumirea structurii organizatorice</b>
                <input
                  v-model="item.name"
                  type="text"
                  class="vInput form-disabled"
                  disabled
                />
              </div>
              <div class="form-group">
                <b class="asterisk">Email-ul structurii organizatorice</b>
                <input
                  v-model="item.email"
                  type="text"
                  class="vInput form-disabled"
                  disabled
                />
              </div>
            </div>

            <div class="form-flex">
              <div class="form-group">
                <b class="asterisk">Tipul structurii organizatorice</b>
                <input
                  :value="item.organizationalStructureType.name"
                  type="text"
                  class="vInput form-disabled"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>

        <div
          style="margin: auto; display: flex; justify-content: center"
          v-if="currentInstitution && models.length == 0"
        >
          <div class="Button2" @click="importDepartments">
            <span class="Btn_content"> Importă structuri </span>
          </div>
        </div>

        <div class="right" v-if="models.length > 0">
          <div @click="saveData()" class="Button1">
            <div class="icon">
              <img
                @load="imgLoaded"
                src="../assets/media/for_table/circle_ADD_new_etap.svg"
                alt=""
              />
            </div>
            <span class="Btn_content">
              {{ btnText }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  INSTITUTIONS_PAGINATED,
  IMPORT_DEPARTMENTS,
  SAVE_DEPARTMENTS,
} from "@/api.js";
import updateRoleStatus from "../mixins/updateUserRoleStatus.js";

export default {
  mixins: [updateRoleStatus],
  props: {
    options: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      models: [],
      editId: null,
      institutionaData: [],
      currentInstitution: null,
    };
  },
  methods: {
    closePanel() {
      this.$emit("closePanel");
    },

    isValid() {
      if (this.models.length === 0) {
        this.$toastr.w("Nu sunt structuri importate.");
        return false;
      }

      return true;
    },

    saveData() {
      if (this.isValid()) {
        const body = {};

        if (this.isSuperadmin) {
          body.institutionId = this.currentInstitution.id;
        }

        SAVE_DEPARTMENTS(body).then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            this.$toastr.s("Structurile organizatorice au fost salvate.");
            this.closePanel();
          } else {
            this.$toastr.e(
              res.response || "Salvarea structurilor organizatorice a eșuat.",
            );
          }
        });
      }
    },
    syncInstitutions() {
      const warn = (msg, isWarning) => {
        if (isWarning) {
          this.$toastr.w(msg || "Nu sunt instituții disponibile de selectat.");
        } else {
          this.$toastr.e(msg || "Datele instituțiilor nu au fost primite.");
          this.closePanel();
        }
      };

      INSTITUTIONS_PAGINATED(1, 5000)
        .then((res) => {
          if (Array.isArray(res?.data?.result)) {
            res = res.data.result;

            if (res.length) {
              this.institutionaData = res.map((e) => ({
                ...e,
                id: e.id ?? this.makeid(8),
                name: e.name ?? "-",
              }));
            } else {
              warn(false, true);
            }
          } else {
            warn();
          }
        })
        .catch(warn);
    },
    readAndSyncData(data) {
      if (!this.isObject(data)) return;

      const x = this.models;
      data = { ...data };

      Object.keys(x).forEach((key) => {
        if (data.hasOwnProperty(key)) x[key] = data[key];
      });

      return { ...x };
    },

    importDepartments() {
      this.setLoad(true);

      let query = null;

      if (this.isSuperadmin) {
        query = `?institutionId=${this.currentInstitution.id}`;
      }

      IMPORT_DEPARTMENTS(query)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            const models = res.data;

            this.$nextTick(() => {
              this.models = models;
            });
          } else {
            if (this.isObject(res.response)) {
              this.$toastr.e(res?.response?.message);
            } else {
              this.$toastr.w(res.response);
            }
          }
          this.setLoad();
        })
        .catch(() => {
          this.$toastr.e(
            "Importul structurilor organizatorice a eșuat. Încercați mai târziu.",
          );
          this.setLoad();
        });
    },
  },

  watch: {
    currentInstitution: {
      async handler(val) {
        if (val && val.id) {
          await this.importDepartments();
        } else {
          this.models = [];
        }
      },
      deep: true,
      immediate: true,
    },
    deep: true,
    immediate: true,
  },
  computed: {
    action() {
      return this.options.action || "create";
    },

    btnText() {
      return "Salvează";
    },

    showTotalRecords() {
      return Number.isInteger(this.totalRecords);
    },
    totalRecords() {
      return this.models.length;
    },
  },

  created() {
    this.updateRoleStatus();

    this.$nextTick(() => {
      if (this.isSuperadmin) {
        this.syncInstitutions();
      } else {
        const userInstitution = this.getUserInstitution(true);
        this.currentInstitution = userInstitution?.id ?? null;
      }
    });
    if (this.action == "edit") {
      const data = this.options.data;

      if (this.isObject(data)) {
        this.editId = this.options.data?.id ?? null;
        this.options.data = this.readAndSyncData(data);
      }
    }
  },
};
</script>

<style src="../assets/profile.css"></style>
<style src="../assets/administration.css"></style>

<style lang="scss">
.departments-container {
  max-height: 400px;
  overflow-y: auto;

  .Administration_panel,
  .Administration_panel_block {
    width: auto;
  }
}

.departments-container::-webkit-scrollbar {
  width: 8px !important;
}

.departments-container::-webkit-scrollbar-track {
  background: rgba(121, 60, 60, 0.05);
}

.departments-container::-webkit-scrollbar-thumb {
  background: rgba(121, 60, 60, 0.05);
}

.departments-container::-webkit-scrollbar-thumb:hover {
  background: rgba(121, 60, 60, 0.05);
}
</style>
